export default {
  targetElement: null,
  contentComponent: null,
  maskComponent: null,
  attachment: null,
  targetAttachment: null,
  colour: null,
  width: null,
  componentData: null,
  customClass: '',
}
